import { FormElementAttributes } from "@types";
import classNames from "classnames";

interface Props extends FormElementAttributes {}

const SubmitInput: React.FC<Props> = (props) => {
  const { commonAttrs, classes } = props;
  const { name, id } = commonAttrs;

  return (
    <input
      type={"submit"}
      name={name}
      className={classNames(classes.join(" "))}
      id={id}
    />
  );
};

export default SubmitInput;
